window.initSmartForm = function (code, callback = () => { }) {
    var scriptTag = document.createElement('script');

    window.smartform = window.smartform || {};
    window.smartform.beforeInit = function () {
        window.smartform.setClientId(code);
    }
    window.smartform.afterInit = callback;

    scriptTag.src = 'https://secure.smartform.cz/api/v1/smartform.js';

    document.head.appendChild(scriptTag);
}

window.initSmartFormInput = function (id, country = 1, inputs = {}) {
    setCountryForSmartformInstance(id, country)

    window.smartform.getInstance(id).addAnnounceCallback(function (validationType, addressArray) {
        if (validationType == window.smartform.ValidationResultType.HIT) {
            if (addressArray[0]) {
                document.querySelector('input[name="' + inputs['address'] + '"]').value = addressArray[0].STREET + ' ' + addressArray[0].NUMBER_WHOLE;
                document.querySelector('input[name="' + inputs['city'] + '"]').value = addressArray[0].CITY.split(' - ')[0];
                document.querySelector('input[name="' + inputs['postCode'] + '"]').value = addressArray[0].ZIP;
            }
        } else {
            // clean
        }
    });
}

window.setCountryForSmartformInstance = function (id, country) {
    var countryMap = {
        1: 'SK',
        56: 'CZ'
    };

    if (window.smartform.getInstance === undefined) {
        return;
    }

    if (countryMap[country] == undefined) {
        window.smartform.getInstance(id).setAllOraclesEnabled(false)
        document.querySelector('.' + id).disabled = true;
        return;
    }

    if (countryMap[country] == 'SK') {
        window.smartform.setNewSlovakRegister(true);
    }

    window.smartform.getInstance(id).setAllOraclesEnabled(true);
    document.querySelector('.' + id).disabled = false;
    window.smartform.getInstance(id).setCountry(countryMap[country])
}

window.destroySmartform = function (id) {
    window.smartform.unbindForm(id);
}